(function () {
  "use strict";

  var ROOT_SELECTOR = "[data-soft-life-ritual]";

  var SCENTS = {
    glow: {
      name: "Soft Life Glow",
      notes: "Vanilla · Marshmallow · Caramel · Musk",
      urlKey: "glow-url",
      imageKey: "glow-image"
    },
    champagne: {
      name: "Champagne Dreams",
      notes: "Champagne · Berries · Violet · Cashmere Musk",
      urlKey: "champagne-url",
      imageKey: "champagne-image"
    },
    datenight: {
      name: "Date Night",
      notes: "Rose · Jasmine · Amber · Vanilla Bean",
      urlKey: "datenight-url",
      imageKey: "datenight-image"
    },
    rich: {
      name: "Rich Energy",
      notes: "Amber · Saffron · Cedar · Jasmine",
      urlKey: "rich-url",
      imageKey: "rich-image"
    },
    softgirl: {
      name: "Soft Girl Era",
      notes: "Peony · Jasmine · Suede · Musk",
      urlKey: "softgirl-url",
      imageKey: "softgirl-image"
    }
  };

  var MOOD_MAP = {
    cozy: "glow",
    radiant: "champagne",
    confident: "rich",
    soft: "softgirl",
    romantic: "datenight"
  };

  var AFFIRMATIONS = {
    cozy: "Softness is something I deserve—today and every day.",
    radiant: "I am the main character of my own soft life.",
    confident: "I move through the world golden, grounded, and sure.",
    soft: "I give myself permission to slow down and glow.",
    romantic: "I am worthy of tenderness, beginning with my own."
  };

  var FOCUS_STEPS = {
    full: "Glide the oil over your full body in slow, upward strokes—from ankles to shoulders.",
    legs: "Massage the oil into your legs, shoulders, collarbones, and glow zones until your skin looks softly illuminated.",
    pulse: "Press the oil into your pulse points—wrists, neck, and collarbone—so the scent follows you."
  };

  function findClosest(element, selector) {
    while (element && element.nodeType === 1) {
      if (element.matches && element.matches(selector)) {
        return element;
      }
      element = element.parentElement;
    }
    return null;
  }

  function safeFocus(element) {
    if (!element) {
      return;
    }

    element.setAttribute("tabindex", "-1");

    try {
      element.focus({ preventScroll: true });
    } catch (error) {
      element.focus();
    }
  }

  function smoothScroll(element) {
    if (!element || !element.scrollIntoView) {
      return;
    }

    try {
      element.scrollIntoView({
        behavior: "smooth",
        block: "nearest"
      });
    } catch (error) {
      element.scrollIntoView();
    }
  }

  function initRitual(root) {
    var choices = {
      moment: null,
      mood: null,
      scent: "",
      focus: null
    };

    var currentStep = 1;
    var stage = root.querySelector("[data-stage]");
    var resultTemplate = root.querySelector("[data-result-template]");
    var progressLabel = root.querySelector("[data-progress-label]");
    var progressPercent = root.querySelector("[data-progress-percent]");
    var progressBar = root.querySelector("[data-progress-bar]");
    var originalStageMarkup;

    if (
      !stage ||
      !resultTemplate ||
      root.getAttribute("data-slr-initialized") === "true"
    ) {
      return;
    }

    root.setAttribute("data-slr-initialized", "true");
    originalStageMarkup = stage.innerHTML;

    function updateProgress(step) {
      var percent = Math.min(100, Math.max(25, step * 25));

      currentStep = step;

      if (progressLabel) {
        progressLabel.textContent = "Step " + step + " of 4";
      }

      if (progressPercent) {
        progressPercent.textContent = percent + "%";
      }

      if (progressBar) {
        progressBar.style.width = percent + "%";
      }
    }

    function showStep(step) {
      var steps = stage.querySelectorAll("[data-step]");
      var index;
      var active;

      for (index = 0; index < steps.length; index += 1) {
        steps[index].hidden =
          parseInt(steps[index].getAttribute("data-step"), 10) !== step;
      }

      updateProgress(step);
      active = stage.querySelector('[data-step="' + step + '"]');

      if (active) {
        safeFocus(active.querySelector(".slr-question"));
      }

      smoothScroll(stage);
    }

    function pickScent() {
      if (choices.scent) {
        return choices.scent;
      }

      if (choices.mood && MOOD_MAP[choices.mood]) {
        return MOOD_MAP[choices.mood];
      }

      return "glow";
    }

    function buildSteps() {
      var opening;
      var breath;
      var application;
      var close;

      if (choices.moment === "morning") {
        opening = "Begin on clean, slightly damp skin and warm 3–4 drops of oil between your palms.";
      } else if (choices.moment === "datenight") {
        opening = "Set the mood, soften the lighting, and warm 3–4 drops of oil between your palms.";
      } else {
        opening = "Slow the room down and warm 3–4 drops of oil between your palms.";
      }

      breath = "Take three unhurried breaths and let the scent settle around you.";
      application = FOCUS_STEPS[choices.focus] || FOCUS_STEPS.full;
      close = "Pause, notice your glow, and carry this softness into the rest of your day or evening.";

      return [opening, breath, application, close];
    }

    function showResult() {
      var scentKey = pickScent();
      var scent = SCENTS[scentKey];
      var fragment = resultTemplate.content.cloneNode(true);
      var stepsElement = fragment.querySelector("[data-result-steps]");
      var steps = buildSteps();
      var index;
      var item;
      var affirmation = AFFIRMATIONS[choices.mood] || AFFIRMATIONS.cozy;
      var imageUrl = root.getAttribute("data-" + scent.imageKey) || "";
      var productUrl = root.getAttribute("data-" + scent.urlKey) || "/collections/all";
      var image = fragment.querySelector("[data-product-image]");
      var placeholder = fragment.querySelector("[data-product-placeholder]");
      var shopLink = fragment.querySelector("[data-shop-link]");
      var result;

      fragment.querySelector("[data-result-scent]").textContent = scent.name;
      fragment.querySelector("[data-result-notes]").textContent = scent.notes;
      fragment.querySelector("[data-result-affirmation]").textContent =
        "“" + affirmation + "”";

      for (index = 0; index < steps.length; index += 1) {
        item = document.createElement("li");
        item.textContent = steps[index];
        stepsElement.appendChild(item);
      }

      if (shopLink) {
        shopLink.setAttribute("href", productUrl);
      }

      if (imageUrl && image) {
        image.setAttribute("src", imageUrl);
        image.setAttribute("alt", scent.name);
        image.hidden = false;

        if (placeholder) {
          placeholder.hidden = true;
        }
      } else {
        if (image) {
          image.hidden = true;
        }

        if (placeholder) {
          placeholder.hidden = false;
        }
      }

      while (stage.firstChild) {
        stage.removeChild(stage.firstChild);
      }

      stage.appendChild(fragment);

      if (progressLabel) {
        progressLabel.textContent = "Your ritual";
      }

      if (progressPercent) {
        progressPercent.textContent = "Complete";
      }

      if (progressBar) {
        progressBar.style.width = "100%";
      }

      /* Save this completed consultation to the correct Website or Event Passport. */
      if (window.SoftLifePassport && window.SoftLifePassport.saveResult) {
        window.SoftLifePassport.saveResult({
          toolKey: "build-your-ritual",
          title: "Build Your Ritual",
          recommendation: scent.name,
          product: scent.name,
          mood: choices.mood || "",
          notes: scent.notes,
          affirmation: affirmation,
          ritualSteps: steps,
          answers: {
            moment: choices.moment,
            mood: choices.mood,
            scent: scentKey,
            focus: choices.focus
          },
          productUrl: productUrl
        });
      }

      result = stage.querySelector("[data-result]");
if (result) {
  var returnWrap = document.createElement("div");

  returnWrap.className = "slr-passport-return";
  returnWrap.style.marginTop = "18px";

  returnWrap.innerHTML =
    '<a href="/pages/soft-life-concierge?sle_return=passport" ' +
    'style="display:block; width:100%; padding:15px 20px; ' +
    'text-align:center; text-decoration:none; ' +
    'background:#A8854C; color:#FFFFFF; ' +
    'font-size:12px; letter-spacing:1.5px; text-transform:uppercase;">' +
    'Return to My Soft Life Passport</a>';

  result.appendChild(returnWrap);
}
      /* Always give the guest a clear route back to the Passport. */
      if (result && window.SoftLifePassport) {
        var returnWrap = document.createElement("div");
        returnWrap.className = "slr-passport-return";
        returnWrap.innerHTML =
          '<a class="slr-button slr-button--secondary" href="' +
          window.SoftLifePassport.getReturnUrl("passport") +
          '">Return to My Soft Life Passport</a>';
        result.appendChild(returnWrap);
      }

      safeFocus(result ? result.querySelector("[data-result-scent]") : null);
      smoothScroll(stage);
    }

    function reset() {
      choices = {
        moment: null,
        mood: null,
        scent: "",
        focus: null
      };

      stage.innerHTML = originalStageMarkup;
      showStep(1);
    }

    root.addEventListener("click", function (event) {
      var option = findClosest(event.target, ".slr-option");
      var back = findClosest(event.target, "[data-back]");
      var restart = findClosest(event.target, "[data-restart]");
      var group;
      var groupName;
      var options;
      var index;
      var value;

      if (option && root.contains(option)) {
        group = findClosest(option, "[data-group]");

        if (!group) {
          return;
        }

        groupName = group.getAttribute("data-group");
        value = option.getAttribute("data-value") || "";
        options = group.querySelectorAll(".slr-option");

        for (index = 0; index < options.length; index += 1) {
          options[index].classList.remove("is-active");
        }

        option.classList.add("is-active");
        choices[groupName] = value;

        window.setTimeout(function () {
          if (groupName === "moment") {
            showStep(2);
          } else if (groupName === "mood") {
            showStep(3);
          } else if (groupName === "scent") {
            showStep(4);
          } else if (groupName === "focus") {
            showResult();
          }
        }, 180);

        return;
      }

      if (back && root.contains(back)) {
        if (currentStep > 1) {
          showStep(currentStep - 1);
        }
        return;
      }

      if (restart && root.contains(restart)) {
        reset();
      }
    });

    updateProgress(1);
  }

  function initAll(scope) {
    var container = scope || document;
    var roots = container.querySelectorAll(ROOT_SELECTOR);
    var index;

    for (index = 0; index < roots.length; index += 1) {
      initRitual(roots[index]);
    }
  }

  function start() {
    initAll(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
}());
